export const environment = {
  production: false,
  // ----- Chevron Authentication Library (CAL / Azure AD) -----
  isLocalhost: false,
  // AAD Group ObjectId whose members can see the Danger Zone section.
  // Leave empty to hide the Danger Zone from everyone.
  adminGroupId: 'a19d4e21-0cd6-4d44-803e-13563fe21bc9',
  calTenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  calClientId: '00420aab-fd2d-49b1-b937-0eaf6862db92',
  calRedirectUri: 'https://conshub-loader-dev-cvx.azure.chevron.com',
  // -----------------------------------------------------------
  clientId: '1cbf0646e60ab41874cffd11e619e090',
  appKey: 'cf890749928630d1a052d6107e93116d',
  // For confidential clients (Web server application): set this to the client_secret
  // from CSI app registration. Leave empty string for public SPA clients.
  clientSecret: '',
  authorizationEndpoint: 'https://csi.slb.com/v2/auth',
  tokenEndpoint: 'https://csi.slb.com/v2/token',
  // Scope for the CSI token request.
  // Production:  'openid fwk-drillplan.slbservice.com'
  // Sandbox:     'openid <sandbox-azure-app-id>/.default'
  //              Find the app ID in Azure portal → App registrations → admeusscintcvx → "Expose an API"
  scope: 'openid fwk-drillplan.slbservice.com',
  consumptionHubPath: '/drillplan/consumptionHub/v1/ingress',
  dataSource: 'Angular Web App',
  allowedSlbPartitionIds: ['b1b2293379dce8acc541ffc4e026141f'],
  redirectUri: 'http://conshub-loader-dev-cvx.azure.chevron.com/auth/callback',
  // Routes all DELFI API calls through the IIS reverse proxy in web.config (ARR module).
  // This avoids CORS — the browser talks to the same origin, IIS forwards server-side.
  // Requires App Service platform to be set to 64-bit (ARR doesn't work on 32-bit).
  // The same path is used locally via the Angular dev server proxy (proxy.conf.json).
  apiBaseUrlOverride: '/proxy/delfi-api'
};
